import React, { useEffect, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: '5px 5px 8px 8px',
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const focusedStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

function StyledDropzone(props: any) {
  const [tmpFile, setTmpFile] = useState<File[]>();
  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
    useDropzone({
      accept: props.accept || ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 'text/csv'],
      onDrop: (files) => {
        if (props.setFiles && files.length > 25) {
          alert('Max 25 files allowed');
          props.setFiles && props.setFiles([]);
          setTmpFile(undefined);
          return;
        }

        if (files.length === 0 && props.setFiles) {
          props.setFiles([]);
          setTmpFile(undefined);
        }

        if (files.length > 0 && props.setFiles) {
          props.setFiles(files);
          setTmpFile(files);
        }

        if (props.setFile && files.length > 1) {
          alert("Only one file allowed");
          props.setFile(undefined);
          setTmpFile(undefined);
          return;
        }

        if (props.setFile && files.length === 0) {
          props.setFile(undefined);
          setTmpFile(undefined);
        }

        if (props.setFile && files.length === 1) {
          props.setFile(files[0]);
          setTmpFile(files);
        }
      },
    });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  useEffect(() => {
    if (props.isFileUploaded) {
      setTmpFile(undefined);
    }
  }, [props.isFileUploaded])

  return (
    <div>
      {/* @ts-ignore next-line */}
      <div {...getRootProps({ style })}>
        <h5>
          {tmpFile
            ? `Selected: ${tmpFile.length} files`
            : (props.title || "Click/drag and drop PDFs/Docx.")}
        </h5>
        <input {...getInputProps()} />
        <img
          src={props.icon || "/file-types.png"}
          alt="file types allowed"
          height="55"
        // style={{
        //   margin: '20px 0px'
        // }}
        />
      </div>
    </div>
  );
}

export default StyledDropzone;
